"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var subscribers = [];

var subscribe = exports.subscribe = function subscribe(fn) {
  if (subscribers.indexOf(fn) === -1) {
    subscribers = [].concat(_toConsumableArray(subscribers), [fn]);
  }
};

var unsubscribe = exports.unsubscribe = function unsubscribe(fn) {
  subscribers = subscribers.filter(function (x) {
    return x !== fn;
  });
};

var emit = exports.emit = function emit() {
  subscribers.forEach(function (fn) {
    return fn();
  });
};